import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=e20b69fc&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=e20b69fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e20b69fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e20b69fc')) {
      api.createRecord('e20b69fc', component.options)
    } else {
      api.reload('e20b69fc', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=e20b69fc&scoped=true&", function () {
      api.rerender('e20b69fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2jIO6FjlePZlo/JS/comp/PopupBox.vue"
export default component.exports